import { getField, updateField } from "vuex-map-fields";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import EmojiKeyService from "@/views/sidebar/emoji-key/emoji-key.service";
import { Icon } from "@/views/sidebar/emoji-key/emoji-key.types";

@Module({ namespaced: true })
class EmojiKey extends VuexModule {
  emojiKeys: Icon[] = [];

  private _initialState!: Record<string, any>;

  constructor(module: any) {
    super(module);
    this._initialState = { ...this };
  }

  @Action({ rawError: true })
  async fetchEmojiKeys(clientId: number) {
    this.context.commit("updateField", {
      path: "emojiKeys",
      value: []
    });
    const emojiKeys =  await EmojiKeyService.getEmojiIcons(clientId);
    this.context.commit("updateField", {
      path: "emojiKeys",
      value: emojiKeys
    });
  }

  @Action({ rawError: true })
  resetState() {
    for (const key of Object.keys(this._initialState)) {
      this.context.commit("updateField", {
        path: key,
        value: this._initialState[key]
      });
    }
  }
}

EmojiKey.getters = { getField };
EmojiKey.mutations = { updateField };

export default EmojiKey;